module.exports = __webpack_public_path__ + "img/zain.87ff05d3.svg";